import getEnvironmentVariables from "../utils/environmentVariables";

const { BACKEND_URL_PROD, ENV, BACKEND_URL_STAGING } =
  getEnvironmentVariables();
export const Site_url =
  ENV === "staging" ? "http://staging.ezylegal.in/" : "https://www.ezylegal.in/";
// export const Site_url = 'http://localhost:3002/';
